import React, { useState } from 'react';

import { getAge, isMinor } from '@libs/NwMoment';
import { showDateNoTimeAsDateOnly } from '@libs/NwMoment';

import { useUserPermission } from '@contexts/UserContext';

import AnagraphicalDrawer from '@components/ContactDetails/CommonComponents/Anagraphical/AnagraphicalDrawer';

import CountryLabel from '@components/Gui/CountryLabel';
import NwIcon, { NwGenderIcon } from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactDetailsHeaderAnagraphical = ({ contact, iconSize, readOnly, noDrawer, mobileFullRow, stacked }) => {
    const [drawer, setDrawer] = useState(false);

    const userids = contact && contact.users ? contact.Users.map((user) => user.UserID) : [];

    const contactType = contact.SubType > 3 ? 'model' : 'customer';

    const viewModelAnagraphical = useUserPermission('ViewModelAnagraphical', userids);

    const birthDate = contact.BirthDate || contact.B;
    const nationalityCode = contactType === 'model' ? contact.NationalityCode || contact.NAT : null;
    const gender = contactType === 'model' ? contact.GenderName || contact.G : null;

    const getBirthdayContent = () => {
        if (isMinor(birthDate)) {
            return (
                <>
                    <NwTag type="danger">{getAge(birthDate)} y.o.</NwTag>&nbsp;&nbsp;
                    <NwIcon icon={byPrefixAndName.fasl['birthday-cake']} />
                    &nbsp;&nbsp;{showDateNoTimeAsDateOnly(birthDate)}
                </>
            );
        } else {
            return (
                <>
                    {getAge(birthDate)} y.o.&nbsp;&nbsp;
                    <NwIcon icon={byPrefixAndName.fasl['birthday-cake']} />
                    &nbsp;&nbsp;{showDateNoTimeAsDateOnly(birthDate)}
                </>
            );
        }
    };

    const getModelContent = () => {
        if (!stacked) {
            return (
                <>
                    <NwGenderIcon gender={`${gender}`} />
                    &nbsp;&nbsp;
                    {birthDate ? getBirthdayContent() : `birthday: n.d.`}
                    &nbsp;&nbsp;&nbsp;
                    {nationalityCode && <CountryLabel usecode code={nationalityCode} flag />}
                </>
            );
        }

        return (
            <div className="anagraphical-mobile-details">
                <div>
                    <NwGenderIcon gender={`${gender}`} />
                    <span>{gender}</span>
                </div>
                <div>{birthDate ? getBirthdayContent() : `birthday: n.d.`}</div>
                {nationalityCode && (
                    <div>
                        <CountryLabel usecode code={nationalityCode} flag />
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            <div
                className={`header-body-boxes header-body-boxes-hoverable${mobileFullRow ? ' mobile-full-row-trigger' : ''}`}
                onClick={() => viewModelAnagraphical && setDrawer(true)}
            >
                <PermissionBlock
                    permission={contactType === 'model' ? viewModelAnagraphical : true}
                    content={
                        contact.ContactType === 'Customer' ? (
                            <>
                                <NwIcon size={iconSize} icon={byPrefixAndName.fasl['id-card']} />
                                &nbsp;&nbsp;
                                {birthDate ? getBirthdayContent() : `birthday: n.d.`}
                            </>
                        ) : (
                            getModelContent()
                        )
                    }
                />
            </div>
            {drawer && !noDrawer && (
                <AnagraphicalDrawer
                    currentContact={contact}
                    readOnly={readOnly}
                    type={contact.ContactType === 'Customer' ? 0 : 1}
                    onClose={() => {
                        setDrawer(false);
                    }}
                />
            )}
        </>
    );
};

export default ContactDetailsHeaderAnagraphical;
